import {
  CALL_ME_CALLBACK_URL,
  CALL_ME_X_CLIENT_ID,
  CALL_ME_X_CLIENT_VERSION,
} from "@internal/common";

export enum QueueId {
  Sales = "gjewcbDKPSalgGj",
  PrivatForsikring = "gjeDKPWCBKRGJ",
}

type CallMeSend = {
  errand?: string; //errand id,
  phoneNumber?: string; //<phonenumber on format:  +47XXXXXXXX>, +46XXXXXXXXX>, +45XXXXXXXX>
  entrance?: string;
  menuchoice?: string;
  comment?: string; //Optional,
  customerName?: string; //Optional,
  startTime?: string; //Optional (should be on RFC 3339 format) defaults to now. Ex: 2019-04-23T18:25:43+02:00. Beware of timezone
};

export const QUEUES: Record<QueueId, CallMeSend> = {
  [QueueId.Sales]: {
    errand: "519",
    entrance: "Webb",
    menuchoice: "DK_WCB_Privat",
  },
  [QueueId.PrivatForsikring]: {
    errand: "518",
    entrance: "Webb",
    menuchoice: "Callback",
  },
};

export const sendCallMe = async (
  data: CallMeSend,
  queueId: QueueId,
): Promise<Response> => {
  const body: CallMeSend = {
    ...QUEUES[queueId],
    ...data,
    phoneNumber: phoneNumberPrefix(data.phoneNumber),
  };

  return await fetch(CALL_ME_CALLBACK_URL, {
    method: "POST",
    headers: {
      Accept: "application/json; charset=UTF-8",
      "Content-Type": "application/json; charset=UTF-8",
      "X-ClientId": CALL_ME_X_CLIENT_ID,
      "X-ClientVersion": CALL_ME_X_CLIENT_VERSION,
    },
    body: JSON.stringify(body),
    mode: "cors", // no-cors, cors, *same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    redirect: "follow", // manual, *follow, error
    referrer: "no-referrer", // no-referrer, *client
  });
};

export type CallMeResult = {
  httpStatus: number;
  data: {
    code: string;
  };
};

export const getHttpStatusAndJson = async (
  response: Response,
): Promise<CallMeResult> => {
  try {
    const data = await response.clone().json();
    return {
      httpStatus: response.status,
      data,
    };
  } catch (e) {
    return {
      httpStatus: response.status,
      data: {
        code: "0",
      },
    };
  }
};

const phoneNumberPrefix = (phoneNumber?: string) => {
  if (phoneNumber?.startsWith("0045")) {
    return phoneNumber.replace("0045", "+45");
  }
  if (phoneNumber?.startsWith("+45")) {
    return phoneNumber;
  }
  return `+45${phoneNumber}`;
};
